import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const LazyLogin = lazy(() =>
  import(/* webpackChunkName: 'Login' */ './index'),
);

export default function Login(props) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyLogin {...props} />
    </Suspense>
  );
}
